import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AUTH_TOKEN_REFRESH_WINDOW_SECONDS } from 'lib/core/resources/constants'
import { PWAThunk } from 'lib/core/data'
import { setSession } from 'lib/core/data/auth/session'
import { Slice, RefreshCustomerTokenPayload } from './types'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: undefined
}

const slice = createSlice({
  name: 'customer/tokenRefresh',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<RefreshCustomerTokenPayload>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function refreshCustomerToken (): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())

    try {
      const response = await magentoClient.getClient().customer.tokenRefresh()
      const data = response.data?.refreshCustomerToken
      if (data?.token) {
        dispatch(success(data))
        const tokenExpiration = data.expiration_timestamp
        const scheduleRefresh = tokenExpiration
          ? (parseInt(tokenExpiration) - AUTH_TOKEN_REFRESH_WINDOW_SECONDS) * 1000
          : undefined

        await dispatch(setSession(data.token, scheduleRefresh))
      } else {
        dispatch(failure())
      }
    } catch (e) {
      dispatch(failure())
    }
  }
}
